import { orchestrator, type OrchestratorFunction } from "satcheljs";
import { onCoprincipalBootStateChanged } from "owa-account-source-list-store";
import { getAddAccountCampaignStore } from "../store/AddAccountCampaignStore";
import { setAddAccountCampaignViewStateMutator } from "../mutators/setAddAccountCampaignViewStateMutator";
import type { ON_COPRINCIPAL_BOOTSTATE_CHANGEDActionMessage } from "owa-account-source-list-store";

export const accountStateChangeOrchestrator: OrchestratorFunction<ON_COPRINCIPAL_BOOTSTATE_CHANGEDActionMessage> = orchestrator(onCoprincipalBootStateChanged, () => {
    if (getAddAccountCampaignStore().viewState === "CAMPAIGN_READY") {
        setAddAccountCampaignViewStateMutator("CLOSED");
    }
});
